module.exports = __webpack_public_path__ + "img/fort-awesome.35fb43e1.svg";